import {ModuleConfiguration} from "../router/model/UserPermission";
import {ContactProfileModuleName} from "../utils/names/optionalModuleNames";

export const ContactProfileModuleConfig = new ModuleConfiguration(ContactProfileModuleName,
    [
        ContactProfileModuleName
    ])

export default ContactProfileModuleConfig;